<!--
 * @Author: lishiqiao
 * @Date: 2021-12-22 09:52:28
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-10-25 13:59:56
-->
<template>
  <div class="case">
    <div class="case-box">
      <div class="title">{{ $t("route.case") }}</div>
      <!-- 轮播图 -->
      <swiper
        class="swiper"
        :options="swiperOption"
      >
        <swiper-slide
          v-for="item of page"
          :key="item"
        >
          <div
            class="swiper-box-item"
            v-for="item1 of swiperList[item - 1]"
            :key="item1.id"
          >
            <img
              @click="toDetails(item1.id)"
              :src="item1.mainPicture|OSSUrl"
            />
            <div>{{ item1.caseName }}</div>
          </div>
        </swiper-slide>
      </swiper>
      <!-- 上一张 -->
      <div
        class="swiper-button-prev"
        slot="button-prev"
      >
        <!-- svg图标 -->
        <svg
          version="1.1"
          id="图层_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 141.7 141.7"
          style="enable-background: new 0 0 141.7 141.7"
          xml:space="preserve"
        >
          <g>
            <path
              class="st0"
              d="M98.1,135.5c-2.6,0-5.1-0.9-7.1-2.8L40,83.4c-3-2.9-5-6.8-5.3-10.9c-0.4-4.8,1.3-9.4,4.6-12.9l49.4-51
		c3.7-3.8,9.8-4.4,13.9-0.9c4.4,3.8,4.7,10.5,0.7,14.6L60.9,66.1c-2.7,2.8-2.6,7.2,0.2,9.8l43.9,42.5c4,3.8,4.1,10.2,0.2,14.1
		C103.2,134.5,100.7,135.5,98.1,135.5z"
            />
          </g>
        </svg>
      </div>
      <!-- 下一张 -->
      <div
        class="swiper-button-next"
        slot="button-next"
      >
        <svg
          version="1.1"
          id="图层_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 141.7 141.7"
          style="enable-background: new 0 0 141.7 141.7"
          xml:space="preserve"
        >
          <g>
            <path
              class="st0"
              d="M44.5,135.5c2.6,0,5.1-0.9,7.1-2.8l51-49.4c3-2.9,5-6.8,5.3-10.9c0.4-4.8-1.3-9.4-4.6-12.9l-49.4-51
		C50.2,4.7,44.1,4.2,40,7.6c-4.4,3.8-4.7,10.5-0.7,14.6l42.5,43.9c2.7,2.8,2.6,7.2-0.2,9.8l-43.9,42.5c-4,3.8-4.1,10.2-0.2,14.1
		C39.4,134.5,41.9,135.5,44.5,135.5z"
            />
          </g>
        </svg>
      </div>
      <div
        class="swiper-pagination"
        slot="pagination"
      ></div>
    </div>
  </div>
</template>

<script>
import http from "../../../axios/index.js";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "case",
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      page: 0, // 轮播图个数
      swiperList: [], // 轮播图列表
      swiperOption: {
        spaceBetween: 45, // 轮播图间距
        autoplay: true, // 默认自动轮播
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      params: {
        page: 1,
        pageSize: 15,
        orders: { sequence: "desc" },
        param: {
          lang: "zh_CN",
        },
      },
      customerCaseList: [],
    };
  },
  props: {
    msg: String,
  },
  created() {
    if (this.$i18n.locale === "zh") {
      this.params.param.lang = "zh_CN";
    } else if (this.$i18n.locale === "en") {
      this.params.param.lang = "en";
    }
    this.customerCaseList = [];
    this.getCustomerCaseList();
  },
  mounted() {},
  watch: {
    "$i18n.locale"(newValue) {
      if (newValue === "zh") {
        this.params.param.lang = "zh_CN";
      } else {
        this.params.param.lang = "en";
      }
      this.customerCaseList = [];
      this.getCustomerCaseList();
    },
  },
  methods: {
    /**
     * @Author: lishiqiao
     * @Date: 2022-01-04 19:23:45
     * @description: 获取轮播图
     * @param {*}
     */
    getCustomerCaseList() {
      const url = `/frontCustomerCase/page`;
      http
        .post(url, this.params)
        .then((res) => {
          if (res.code === "00000") {
            this.customerCaseList = res.data.list;
            this.page = Math.ceil(this.customerCaseList.length / 6);
            this.getSwiperList();
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    // 跳转详情页
    toDetails(id) {
      this.$router.push({
        path: "case-details",
        query: {
          id,
        },
      });
    },

    // 处理轮播图数据
    getSwiperList() {
      this.swiperList = [];
      for (let i = 0; i < this.page; i++) {
        const pageItem = [];
        pageItem = this.customerCaseList.slice(i * 6, (i + 1) * 6);
        this.swiperList.push(pageItem);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.case {
  box-sizing: border-box;
  text-align: center;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .case-box {
    position: relative;
    width: 116.75rem;
    height: 63.75rem;
    margin-top: -0.33rem;

    .title {
      box-sizing: border-box;
      font-size: 1.74rem;
      //font-family: Alibaba PuHuiTi;
      font-family: Alibaba-PuHuiTi-Medium;
      font-weight: 500;
      color: #2b2b2b;
      line-height: 1.67rem;
      position: absolute;
      left: 0;
      right: 0;
      //top: 0.9rem;
      top: 1.3rem;
    }

    .swiper {
      box-sizing: border-box;
      width: 91.33rem;
      height: 45.08rem;
      margin-top: 9.33rem;

      .swiper-wrapper {
        .swiper-slide {
          width: 100% !important;
          height: 100% !important;
          display: flex;
          flex-wrap: wrap;

          .swiper-box-item {
            box-sizing: border-box;
            width: 27.67rem !important;
            height: 21.25rem !important;
            border-radius: 1rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-right: 4.16rem !important;
            img {
              box-sizing: border-box;
              width: 27.67rem;
              height: 18.75rem;
              background: #ffffff;
              border-radius: 1rem;
            }

            div {
              box-sizing: border-box;
              font-size: 1.33rem;
              line-height: 1.33rem;
              //font-family: Alibaba PuHuiTi;
              font-family: AlibabaPuHuiTi-Regular;
              font-weight: 400;
              color: #2b2b2b;
              line-height: 1.33rem;
            }
            &:nth-child(3),
            &:nth-child(6) {
              margin-right: 0 !important;
            }
            &:nth-child(4),
            &:nth-child(5),
            &:nth-child(6) {
              margin-top: 2.58rem;
            }
          }
        }
      }
    }

    .swiper-button-prev {
      box-sizing: border-box;
      width: 6.17rem;
      height: 5.58rem;
      top: 28.5rem;
      left: 1.58rem;

      &::after {
        display: none;
      }
      .st0 {
        fill: #ffffff;
      }
    }

    .swiper-button-next {
      width: 6.17rem;
      height: 5.58rem;
      top: 28.5rem;
      right: 2.33rem;
      &::after {
        display: none;
      }
      .st0 {
        fill: #ffffff;
      }
    }

    .swiper-button-disabled {
      opacity: 1;
      .st0 {
        fill: #d9d9d9;
      }
    }

    .swiper-pagination {
      left: 0;
      right: 0;
      bottom: 2.83rem;

      /deep/.swiper-pagination-bullet {
        width: 5.17rem !important;
        height: 1rem !important;
        background: #d9d9d9;
        border-radius: 1rem;
        margin-right: 2.5rem;
        opacity: 1;
      }

      /deep/.swiper-pagination-bullet-active {
        background: #ffffff;
      }
    }
  }
}
</style>
